// extracted by mini-css-extract-plugin
export default {"view":"ParticipantView_view__LJ6I8","box":"ParticipantView_box__4qjdN"};